import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { SOLUTIONS } from '../../core/constants/solutions';
import { ISolution } from '../../core/models/solution.model';
import { SolutionsListComponent } from './components/solutions-list/solutions-list.component';
import { ContactUsComponent } from '../../shared/components/contact-us/contact-us.component';
import { FormProtectionComponent } from './components/form-protection/form-protection.component';
import { FormBuildComponent } from './components/form-build/form-build.component';
import { FormManagementComponent } from './components/form-management/form-management.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-solutions',
  templateUrl: './solutions.component.html',
  styleUrls: ['./solutions.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SolutionsListComponent,
    ContactUsComponent,
    FormProtectionComponent,
    FormBuildComponent,
    FormManagementComponent
  ]
})
export class SolutionsComponent implements OnInit {
  solutions = SOLUTIONS;
  solutionSelected?: ISolution;
  showFormCalculate: boolean = false;
  showLogo: boolean = true;
  isResponsive: boolean = false;

  constructor(
    private activateRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activateRoute.queryParams.subscribe(params => {
      const id = params['id'];
      if (id) {
        let solutionsFind = this.solutions.find(s => s.id === Number(id));
        if (solutionsFind) {
          this.solutionSelected = solutionsFind;
        }else {
          this.solutionSelected = this.solutions[0];
        }
      }else {
        this.solutionSelected = this.solutions[0];
      }
    });
  }

  ngDoCheck() {
    this.checkScreenSize();
  }

  selectSolution(item: ISolution) {
    this.showLogo = true;
    this.showFormCalculate = false;
    this.solutionSelected = item;
    setTimeout(() => {
      scrollTo(0, 0);
    });
  }

  @HostListener('window:resize', [])
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      return;
    }
    const width = window.innerWidth;
    this.isResponsive = width <= 992;
  }

}
